export default __webpack_public_path__ + "static/media/2.62b79217.png";